import { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import Spinner from 'react-bootstrap/Spinner';
import DataBrowsePaginator from './DataBrowsePaginator.js';

function parseTableDataFromCSVString(csvString) {
    const rows = csvString.split('\n');
    const header = rows[0].split(',');
    const result = [];
    for (let i = 1; i < rows.length-1; i++) {
        const rowData = rows[i].split(',');
        const rowObj = {};
        rowData.forEach((val, idx) => rowObj[header[idx]] = val);
        result.push(rowObj);
    }
    return result;
}

function DataBrowseTable(props) {

    const { domain, filename } = props;

    const [ tableData, setTableData ] = useState([]);

    const [ activePage, setActivePage ] = useState(0);

    const [ paginationItemCount, setPaginationItemCount ] = useState(0);
    
    // eslint-disable-next-line
    useEffect(() => {
        fetch(`https://e4tiu28fl2.execute-api.us-west-2.amazonaws.com/prod/datafile/${domain}/${filename}`)
        .then((response) => response.json())
        .then((json) => {
            const tableData = parseTableDataFromCSVString(json['data']);
            setTableData(tableData);
            setPaginationItemCount(Math.ceil(tableData.length / 10));
        })
        // eslint-disable-next-line
    }, []);

    if (tableData.length > 0) {
        const tableDataSlice = tableData.slice(activePage*10, activePage*10 + 10);
        return (
            <div style={{height: '100%', marginTop: '1.5em'}}>
                <div style={{height: '50vh', overflow: 'auto'}}>
                <Table 
                    responsive striped hover 
                    style={{fontSize: '0.75em', width: '80%', margin: '0 auto', marginTop: '0.5em', overflow: 'auto'}}
                    size="sm"
                >
                    <thead>
                        <tr>
                            <th>#</th>
                            {Object.keys(tableData[0]).map((colName, idx) => <th key={idx}>{colName.split(' ').join('\n')}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {tableDataSlice.map((row, idx) => (
                        <tr key={idx}>
                            <td>{idx+1 + activePage*10}</td>
                            {Object.keys(row).map((key, idx) => (
                                <td key={idx}>{row[key]}</td>
                            ))}
                        </tr>  
                        ))}
                    </tbody>
                </Table>
                </div>
                <DataBrowsePaginator 
                    handleClickBegin={() => setActivePage(0)}
                    handleClickLeft={() => setActivePage(Math.max(0, activePage - 1))}
                    handleClickRight={() => setActivePage(Math.min(paginationItemCount - 1, activePage + 1))}
                    handleClickEnd={() => setActivePage(paginationItemCount - 1)}
                    activePage={activePage}
                    tableData={tableData}
                    paginationItemCount={paginationItemCount}
                />
            </div>
        );
    } else {
        return (
            <div style={{height: '100%', marginTop: '1.5em'}}>
                <div style={{height: '50vh', textAlign: 'center'}}>
                    <h5 style={{display: 'inline'}}>Loading...</h5>
                    <Spinner animation='border'></Spinner>
                </div>
            </div>
        )
    }
    

}


export default DataBrowseTable;